import React from 'react';
import { Documents } from '../pages/Documents';

export const documentsRoutePage = {
  component: <Documents />,
  route: '/documents',
};
